import { useEffect } from 'react';
import { useNow } from '../../../hooks/useNow';
import { usePageHeader } from '../../../providers/PageHeaderProvider';
import { formatUpdatedAgo } from './overviewTime';

const CLOCK_TICK_MS = 15_000;
const BASE_SUBTITLE = 'Live DM workload';

interface OverviewHeaderSyncProps {
    generatedAt: string | null;
    refreshFailed: boolean;
}

function subtitleText(generatedAt: string | null, now: number, refreshFailed: boolean): string {
    if (!generatedAt) return BASE_SUBTITLE;
    const updated = `${BASE_SUBTITLE} · updated ${formatUpdatedAgo(generatedAt, now)}`;
    return refreshFailed ? `${updated} · couldn't refresh, retrying` : updated;
}

// Owns the clock, so its ticks re-render only this and the header, never the cards.
// No spinner on polls: a flash every minute is flicker; "updated just now" says it refreshed.
export function OverviewHeaderSync({ generatedAt, refreshFailed }: OverviewHeaderSyncProps) {
    const { setTitle, setSubtitle } = usePageHeader();
    const now = useNow(CLOCK_TICK_MS);
    const subtitle = subtitleText(generatedAt, now, refreshFailed);

    useEffect(() => {
        setTitle('Overview');
        return () => {
            setTitle(null);
            setSubtitle(null);
        };
    }, [setTitle, setSubtitle]);

    useEffect(() => {
        setSubtitle(subtitle);
    }, [subtitle, setSubtitle]);

    return null;
}
